import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import Loader from "../../../components/common/loader";
import { BreadCrumb } from "primereact/breadcrumb";
import { ReactComponent as HomeIcon } from "../../../assets/images/home.svg";
import { toast } from "react-toastify";
import { getAppCmsPageDetails } from "../../../services/app.cms.pages.service";

const CMSDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [cmsData, setCmsData] = useState<any>({});

  useEffect(() => {
    if (id) {
      loadCmsPage(Number(id));
    }
  }, [id, location.pathname]);

  const loadCmsPage = async (pageId: number) => {
    setLoading(true);
    try {
      const response = await getAppCmsPageDetails(pageId);
      if (response.statusCode === 200) {
        setCmsData(response.data);
      } else {
        toast.error(response.msg || "Failed to fetch CMS page.");
      }
    } catch (error) {
      toast.error("Error fetching CMS page.");
    } finally {
      setLoading(false);
    }
  };

  const items = [{ label: "CMS Pages" }, { label: cmsData.page_name }];
  const home = {
    icon: <HomeIcon style={{ width: "1rem", height: "1rem" }} />,
    url: "/dashboard",
  };

  return (
    <React.Fragment>
      <Loader isLoading={loading} />
      <Card className="overflow-auto border-0 rounded-bottom-0 h-100 page-card-content px-3 pt-3">
        <Card.Header className="fs-5 fw-semibold  d-flex flex-wrap gap-2 align-items-center bg-body-tertiary border-0 px-0 pt-0 pb-3">
          <div className="w-100">
            <BreadCrumb model={items} home={home} />
          </div>
          <div className="w-100 d-flex flex-wrap align-items-center justify-content-between mt-3">
            <h5 className="mb-0 me-auto fw-bold text-uppercase">CMS Pages</h5>
          </div>
        </Card.Header>

        <Card.Body className="overflow-auto">
          <h5 className="opacity-75 fw-semibold fs-18 mb-4">
            {cmsData.page_name}
          </h5>

          <Row>
            <Col sm={12} md={12}>
              <div className="mb-3 pb-1">
                <div className="position-relative w-100 ">
                  <p
                    className="mb-0"
                    dangerouslySetInnerHTML={{ __html: cmsData.description }}
                  ></p>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
        <Card.Footer className="d-flex flex-wrap gap-3 justify-content-end py-3 border-top">
          <Link to="/cms-pages" className="btn btn-outline-secondary">
            Back
          </Link>
        </Card.Footer>
      </Card>
    </React.Fragment>
  );
};

export default CMSDetails;
